export default __webpack_public_path__ + "static/media/malan-jewellery.6df28f3e.png";